import {
  faAngleLeft,
  faChevronDown,
  faEye,
  faPen,
  faPlus,
  faTrashCan,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import {
  Button,
  Form,
  InputGroup,
  Modal,
  Table,
  Tab,
  Tabs,
} from "react-bootstrap";
import "./Student.css";
import { IndexUse } from "./IndexUse";
import CustomPaginate from "../../../../../../common/custompaginate/CustomPaginate";

const Student = () => {
  const { country, name, setName, fetch } = IndexUse();

  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleShowDetails = (student) => {
    setSelectedStudent(student);
    setShowDetailsModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailsModal(false);
    setSelectedStudent(null);
  };

  return (
    <>
      <section className="Collage_intern application_section">
        <div className="serach_header">
          <InputGroup className="search_box">
            <Form.Control
              placeholder="Search Student Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="search_input"
            />
            <div className="search_btn">
              <i className="fa fa-search"></i>
            </div>
          </InputGroup>
        </div>

        <div className="Dashboard__ActiveApplications card_box">
          <h5 className="mb-3 card_heading_holder">Students List</h5>

          <div className="custom_table table_scroll">
            <Table borderless responsive hover>
              <thead className="table-light">
                <tr>
                  <th>Sr. No.</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Contact Number</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {country?.data?.length > 0 ? (
                  country.data.map((val, index) => (
                    <tr key={val.id}>
                      <td>
                        {(country.current_page - 1) * country.per_page +
                          index +
                          1}
                      </td>
                      <td>
                        <strong>
                          {val.name} {val.last_name || ""}
                        </strong>
                      </td>
                      <td>{val.email}</td>
                      <td>{val.contact_no}</td>
                      <td>
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => handleShowDetails(val)}
                          title="View Details"
                        >
                          <FontAwesomeIcon icon={faEye} /> View Details
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="text-center py-4 fw-bold text-muted"
                    >
                      No Students Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            <CustomPaginate
              currentPage={country?.current_page || 1}
              totalPages={country?.total_pages || 1}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* ====================== DETAILS MODAL ====================== */}
      <Modal
        show={showDetailsModal}
        onHide={handleCloseModal}
        size="xl"
        centered
        scrollable
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <FontAwesomeIcon icon={faEye} className="me-2" />
            Student Details - {selectedStudent?.name}{" "}
            {selectedStudent?.last_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedStudent && (
            <Tabs defaultActiveKey="personal" className="mb-3" fill>
              {/* Personal & Basic Info */}
              <Tab eventKey="personal" title="Personal Details">
                <Table bordered hover responsive>
                  <tbody>
                    <tr>
                      <th>Full Name</th>
                      <td>
                        {selectedStudent.name} {selectedStudent.last_name || ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>{selectedStudent.email}</td>
                    </tr>
                    <tr>
                      <th>Contact No</th>
                      <td>{selectedStudent.contact_no}</td>
                    </tr>
                    <tr>
                      <th>Date of Birth</th>
                      <td>
                        {selectedStudent.dob
                          ? new Date(selectedStudent.dob).toLocaleDateString(
                              "en-IN",
                            )
                          : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Referral Code</th>
                      <td>{selectedStudent.referal_code || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td>
                        <span
                          className={`badge ${
                            selectedStudent.status ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {selectedStudent.status ? "Active" : "Inactive"}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </Table>

                <h5 className="mt-4">Basic User Details</h5>
                <Table bordered hover>
                  <tbody>
                    <tr>
                      <th>Birth Country</th>
                      <td>
                        {selectedStudent.User_Detail?.birth_country || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Birth State</th>
                      <td>
                        {selectedStudent.User_Detail?.birth_state || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Birth City</th>
                      <td>
                        {selectedStudent.User_Detail?.birth_city || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Nationality</th>
                      <td>
                        {selectedStudent.User_Detail?.nationality || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Gender</th>
                      <td>
                        {selectedStudent.User_Detail?.gender_id === 1
                          ? "Male"
                          : selectedStudent.User_Detail?.gender_id === 2
                          ? "Female"
                          : "Other"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Tab>

              {/* Address & Passport Details */}
              <Tab eventKey="address" title="Address & Passport">
                <Table bordered hover>
                  <tbody>
                    <tr>
                      <th>Passport Number</th>
                      <td>
                        {selectedStudent.UserAddDetail?.passport_number ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Passport Issue Country</th>
                      <td>
                        {selectedStudent.UserAddDetail
                          ?.passport_issue_country || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Passport Expiry Date</th>
                      <td>
                        {selectedStudent.UserAddDetail?.passport_expiry_date
                          ? new Date(
                              selectedStudent.UserAddDetail.passport_expiry_date,
                            ).toLocaleDateString("en-IN")
                          : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Current Address</th>
                      <td>
                        {selectedStudent.UserAddDetail
                          ?.passport_current_address || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Permanent Address</th>
                      <td>
                        {selectedStudent.UserAddDetail?.passport_address ||
                          "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Guardian Name</th>
                      <td>
                        {selectedStudent.UserAddDetail?.guardian_name || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Guardian Contact</th>
                      <td>
                        {selectedStudent.UserAddDetail?.guardian_phone || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Guardian Email</th>
                      <td>
                        {selectedStudent.UserAddDetail?.guardian_email || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Relation</th>
                      <td>
                        {selectedStudent.UserAddDetail?.relation || "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Tab>

              {/* Academic Details - Multiple Records */}
              <Tab eventKey="academic" title="Academic Details">
                {selectedStudent.UserAcademicDetails?.length > 0 ? (
                  <Table bordered hover responsive>
                    <thead className="table-light">
                      <tr>
                        <th>Sr. No.</th>
                        <th>School/College</th>
                        <th>Program</th>
                        <th>Education Level</th>
                        <th>Academic Year</th>
                        <th>Student ID</th>
                        <th>Enrollment Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedStudent.UserAcademicDetails.map(
                        (academic, idx) => (
                          <tr key={academic.id}>
                            <td>{idx + 1}</td>
                            <td>{academic.school_selection || "N/A"}</td>
                            <td>{academic.program_name || "N/A"}</td>
                            <td>{academic.education_level || "N/A"}</td>
                            <td>
                              {academic.academic_year
                                ? new Date(
                                    academic.academic_year,
                                  ).toLocaleDateString("en-IN")
                                : "N/A"}
                            </td>
                            <td>{academic.student_id_number || "N/A"}</td>
                            <td>
                              <span
                                className={`badge ${
                                  academic.enrollment_status
                                    ? "bg-success"
                                    : "bg-warning"
                                }`}
                              >
                                {academic.enrollment_status
                                  ? "Enrolled"
                                  : "Not Enrolled"}
                              </span>
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </Table>
                ) : (
                  <p className="text-muted text-center py-4">
                    No academic records found.
                  </p>
                )}
              </Tab>

              {/* Mobility Intent */}
              <Tab eventKey="mobility" title="Study Abroad Intent">
                <Table bordered hover>
                  <tbody>
                    <tr>
                      <th>Study Abroad Objective</th>
                      <td>
                        {selectedStudent.UserMobilityIntent
                          ?.study_abroad_objective || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Preferred Country</th>
                      <td>
                        {selectedStudent.UserMobilityIntent?.country || "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Previous International Experience</th>
                      <td>
                        {selectedStudent.UserMobilityIntent
                          ?.previous_international_experience
                          ? "Yes"
                          : "No"}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Tab>
            </Tabs>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Student;
